import React, { useContext, useState, useEffect, useRef } from "react";
import Container from "react-bootstrap/Container";
import Header from "../components/Header";
import HomeCarousel from "../Carousal/HomeCarousel";
import BrowseJobs from "./BrowseJobs";
import FindJobs from "./FindJobs";
import Spinner from "./../Assets/Images/spinner.gif";
import "../Assets/css/bootstrap.min.css";
import "../Assets/css/style.css";
import "remixicon/fonts/remixicon.css";
import EmployerFindYou from "./EmployerFindYou";
import FooterTemplate from "./FooterTemplate";
import { CompanyContext } from "../contexts/CompanyContext";
import SearchForm from "./SearchForm";
import toast, { Toaster } from "react-hot-toast";

const HomePage = () => {
  const {
    companyLogo,
    fontFamily,
    headerColor,
    primaryColor,
    secondaryColor,
    loading,
    searchFormPosition,
    isSearching,
    setIsSearching,
  } = useContext(CompanyContext);

  const [showContent, setShowContent] = useState(false);
  const [searchParams, setSearchParams] = useState({});
  const findJobsRef = useRef(null);

  useEffect(() => {
    if (!loading) {
      const timer = setTimeout(() => setShowContent(true), 500);
      return () => clearTimeout(timer);
    } else {
      setShowContent(false);
    }
  }, [loading]);

  useEffect(() => {
    if (searchParams && findJobsRef.current) {
      setTimeout(() => {
        findJobsRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 1000); 
    }
  }, [searchParams]);

  const handleSearch = async (params) => {
    setSearchParams(params);
  };

  return (
    <Container
      fluid
      className="p-0"
      style={{
        fontFamily,
        "--mainColor": primaryColor,
        "--titleColor": secondaryColor,
      }}
    >
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            height: "100vh",
            transition: "opacity 0.5s",
            opacity: loading ? 1 : 0,
          }}
        >
          <img src={Spinner} alt="Loading..." />
        </div>
      ) : (
        <div
          style={{ transition: "opacity 0.5s", opacity: showContent ? 1 : 0 }}
        >
          <Header logo={companyLogo} headerColor={headerColor} />
          <HomeCarousel onSearch={handleSearch} isSearching={isSearching} />
          {searchFormPosition === "bottom" && (
            <SearchForm
              position={searchFormPosition}
              onSearch={handleSearch}
              isSearching={isSearching}
            />
          )}
          <BrowseJobs />
          {searchParams && (
            <div ref={findJobsRef}>
              <FindJobs
                searchParams={searchParams}
                setIsSearching={setIsSearching}
              />
            </div>
          )}
          <EmployerFindYou />
          <FooterTemplate />
        </div>
      )}
      <Toaster />
    </Container>
  );
};

export default HomePage;
